import React from 'react';
import ReactDOM from 'react-dom';
import Slider from "react-slick";
class SliderElement extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "wm-simpleCarousell__innerElement" },
            React.createElement("img", { className: "wm-simpleCarousell__innerElementImage", src: this.props.imageUrl }),
            React.createElement("span", { className: "wm-simpleCarousell__innerElementDescription" }, this.props.shortDescription)));
    }
}
class SimpleCarousell extends React.Component {
    constructor(props) {
        super(props);
        this.slider = React.createRef();
        this.state = {
            currentIndex: 0
        };
    }
    render() {
        if (this.props.elements.length <= 0)
            return React.createElement(React.Fragment, null);
        const elementMarkup = this.props.elements.map((element, index) => {
            return React.createElement(SliderElement, Object.assign({}, element, { key: index.toString() }));
        });
        const selectedElement = this.props.elements[this.state.currentIndex];
        const sliderSettings = {
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '30%',
            adaptiveHeight: true,
            dotsClass: 'wm-simpleCarousell__navigation -scnConstrained',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dotsClass: 'wm-simpleCarousell__navigation',
                        centerMode: false,
                        centerPadding: '0px',
                    }
                }
            ],
            afterChange: slideIndex => this.setState({ currentIndex: slideIndex }),
            appendDots: _ => {
                const startNumber = this.padString((this.state.currentIndex + 1).toString(), 2, '0');
                const endNumber = this.padString(this.props.elements.length.toString(), 2, '0');
                return (React.createElement("div", null,
                    React.createElement("button", { onClick: _ => this.nagivate(-1), className: "wm-simpleCarousell__navigationPrev", type: "button" }, "Previous"),
                    React.createElement("span", { className: "wm-simpleCarousell__navigationInfo" },
                        startNumber,
                        " ",
                        React.createElement("small", null,
                            "/ ",
                            endNumber)),
                    React.createElement("button", { onClick: _ => this.nagivate(1), className: "wm-simpleCarousell__navigationNext", type: "button" }, "Next")));
            }
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "wm-simpleCarousell__inner" },
                React.createElement(Slider, Object.assign({ ref: this.slider }, sliderSettings), elementMarkup))));
    }
    nagivate(direction) {
        if (!this.slider.current)
            return;
        if (direction > 0)
            this.slider.current.slickNext();
        else if (direction < 0)
            this.slider.current.slickPrev();
    }
    padString(str, width, symbol) {
        return str.length >= width ? str : new Array(width - str.length + 1).join(symbol) + str;
    }
}
window.addEventListener('load', _ => {
    const carousells = document.querySelectorAll('.wm-simpleCarousell');
    for (const carousell of carousells) {
        const carousellData = JSON.parse(carousell.dataset.elements);
        ReactDOM.render(React.createElement(SimpleCarousell, Object.assign({}, carousellData)), carousell);
    }
});
